// extracted by mini-css-extract-plugin
export var balance = "points-balance-module--balance--68793";
export var content = "points-balance-module--content--22df7";
export var icon = "points-balance-module--icon--354e4";
export var left = "points-balance-module--left--e85a7";
export var loader = "points-balance-module--loader--e6106";
export var pointsBalance = "points-balance-module--points-balance--b0b34";
export var right = "points-balance-module--right--f93f1";